import * as ReactHookForm from 'react-hook-form';
import * as ValidationSchemas from './schemas';

export { ValidationSchemas };

export const useFormValidation = ReactHookForm.useForm;
